import {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {GET_SUCCESS_MANAGER} from 'store/global/successManager/action';

// The location's dedicated Customer Success Manager, or null when it has none.
// The sidebar and the Help page share it through the store, so a load started
// by either one shows in both.
const useSuccessManager = () => {
  const dispatch = useDispatch();
  const locationId = useSelector((state) => state.user.locationId);
  const {locationId: loadedLocationId, manager} = useSelector(
    (state) => state.successManagerReducer
  );

  // Any load still running is replaced (takeLatest), so a lookup left behind by
  // a location switch can never block this one.
  useEffect(() => {
    if (!locationId || locationId === loadedLocationId) return;
    dispatch(GET_SUCCESS_MANAGER(locationId));
  }, [locationId]);

  return locationId === loadedLocationId ? manager : null;
};

export default useSuccessManager;
